import { CmsProduct } from '../../../types/cmsProduct';
import { shouldUsePdpModal } from '../../../utils/helpers/urlAlias';

/**
 * Whether the rewardModal hash addressed to `componentUniqueKey` opens
 * `ProductDetailsModalMode` rather than `RewardAsideModal`.
 *
 * The opener (`useOfferRewardModal`) and the renderer (`SectionGifts`) react to
 * the same hash, so they have to agree on which modal it addresses — one shared
 * predicate instead of two conditions that can drift apart (CMS-1924).
 */
export const shouldRenderProductDetailModal = (
  componentUniqueKey: string,
  product: Pick<CmsProduct, 'url_alias' | 'title' | 'uid'> | undefined,
): boolean =>
  componentUniqueKey.endsWith('_productDetail') || shouldUsePdpModal(product);
